import commonMixin from '@/mixins/templates/common';
import { TemplateName } from '@/helpers/templateType';

export default {
  mixins : [commonMixin],
  props  : {
    showModal: {
      type    : Boolean,
      default : false
    },
    defaultType: {
      type    : String,
      default : 'default' // default delete info alert
    },
    title: {
      type     : String,
      required : true
    },
    text: {
      type: String
    },
    textSecondaryButton: {
      type: String
    },
    textPrimaryButton: {
      type: String
    },
    isForShowOnlySecondaryButton: {
      type    : Boolean,
      default : false
    },
    saveButtonProperty: {
      type    : Boolean,
      default : false
    },
    disablePrimaryButton: {
      type    : Boolean,
      default : false
    },
    disableSecondaryButton: {
      type    : Boolean,
      default : false
    },
    loadingPrimaryButton: {
      type    : Boolean,
      default : false
    },
    hiddenIcon: {
      type    : Boolean,
      default : false
    },
    icon: {
      type    : String,
      default : null
    },
    iconColor: {
      type    : String,
      default : null
    },
    backgroundIconColor: {
      type    : String,
      default : null
    },
    textStyle: {
      type    : String,
      default : ''
    },
    width: {
      type    : Number,
      default : 440
    }
  },
  data() {
    return {
      TemplateName
    };
  },
  computed: {
    hearderClass() {
      return {
        delete : 'wrapper-modal-header-icon--danger',
        alert  : 'wrapper-modal-header-icon--warning',
        error  : 'wrapper-modal-header-icon--danger'
      }[this.defaultType] || 'wrapper-modal-header-icon--info';
    },
    iconStyle() {
      if (!this.backgroundIconColor && this.templateName !== TemplateName.STREAMING) {
        return '';
      }

      return TemplateName.STREAMING === this.templateName ? `background-color: #19191C` : `background-color: ${this.backgroundIconColor}`;
    }
  },
  methods: {
    getIcon() {
      if (this.icon) {
        return this.icon;
      }

      return {
        delete : 'mdi-trash-can-outline',
        alert  : 'mdi-alert-circle-outline',
        error  : 'mdi-alert-outline'
      }[this.defaultType] || 'mdi-alert-circle-outline';
    }
  }
};
